var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-container"},[_c('button',{staticClass:"custom-btn primary",on:{"click":_vm.goToOrderdb}},[_vm._v("下单库")]),_c('button',{staticClass:"custom-btn secondary",on:{"click":_vm.goToTransorderdb}},[_vm._v("转单库")]),_c('button',{staticClass:"custom-btn outline",on:{"click":_vm.goToPgorderdb}},[_vm._v("海量库")])])
}
var staticRenderFns = []

export { render, staticRenderFns }